/* eslint-disable no-undef */
import store from '../../store';
import { LOGIN, LOGOUT, RENEW } from '../../store/modules/auth';

const AuthHandler = {
    install(Vue, options) {
        /**
         * Check if a user is signed in.
         * @param methodOptions
         * @returns Object or null
         */
        Vue.prototype.$auth = {
            /**
             * Get the currently signed in user.
             * @returns {*} or null
             */
            currentUser() {
                return store.getters.currentUser;
            },

            isAuthenticated() {
                return store.getters.isAuthenticated;
            },

            /**
             * Sign in a user with a username and password.
             * @param username
             * @param password
             * @returns {Promise}
             */
            signInWithUsernameAndPassword(username, password) {
                return store.dispatch(LOGIN, { username, password, role: 'evaluator' });
            },

            /**
             * Create a new user with a username and password
             * @param body
             * @returns {Promise}
             */
            createUserWithUsernameAndPassword(body) {
                return new Promise((resolve, reject) => {
                    Vue.axios.post('auth/register', body)
                        .then((resp) => {
                            resolve(resp);
                        })
                        .catch((e) => {
                            reject(e);
                        });
                });
            },

            /**
             * Activate an account using the activation token
             * @param token
             * @returns {Promise}
             */
            activate(token) {
                return new Promise((resolve, reject) => {
                    Vue.axios.get('auth/activate/' + token)
                        .then((resp) => {
                            resolve(resp);
                        })
                        .catch((e) => {
                            reject(e);
                        });
                });
            },

            /**
             * Renew a user's session
             * @returns {Promise}
             */
            renew() {
                return store.dispatch(RENEW);
            },

            /**
             * Sign out the currently signed in user.
             * @returns {Promise}
             */
            signOut() {
                return store.dispatch(LOGOUT);
            }
        };
    }
};

export default AuthHandler;



// WEBPACK FOOTER //
// ./src/components/auth/AuthHandler.js